module.exports = __webpack_public_path__ + "static/img/login-verification-bg.e8d7151.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/home/login-verification-bg.png
// module id = kkMg
// module chunks = 1